import { useEffect, useRef } from 'react'

export function useKeyboardReposition(isAppleDevice: boolean) {
  const drawerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const { visualViewport } = window
    if (!isAppleDevice || !visualViewport) return undefined

    const handleViewportChange = () => {
      if (!drawerRef.current) return

      const keyboardHeight = window.innerHeight - visualViewport.height
      const isKeyboardOpen = keyboardHeight > 0

      if (isKeyboardOpen) {
        window.scrollTo(0, 0)
        requestAnimationFrame(() => {
          if (!drawerRef.current) return

          const { height } = visualViewport

          drawerRef.current.style.top = '0'
          drawerRef.current.style.height = '100%'
          drawerRef.current.style.maxHeight = `${height}px`
        })
      } else {
        requestAnimationFrame(() => {
          if (!drawerRef.current) return

          drawerRef.current.style.removeProperty('top')
          drawerRef.current.style.removeProperty('height')
          drawerRef.current.style.maxHeight = '90vh'
        })
      }
    }

    visualViewport.addEventListener('resize', handleViewportChange)
    visualViewport.addEventListener('scroll', handleViewportChange)

    return () => {
      visualViewport.removeEventListener('resize', handleViewportChange)
      visualViewport.removeEventListener('scroll', handleViewportChange)
    }
  }, [isAppleDevice])

  return drawerRef
}
